import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';
import { IDocumentNameDialog } from 'src/app/shared/interfaces/IDocument';

@Component({
  standalone: true,
  selector: 'app-document-name-dialog',
  templateUrl: './document-name-dialog.component.html',
  imports: [MaterialModule, ReactiveFormsModule, TranslateModule]
})
export class DocumentNameDialogComponent {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DocumentNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public config: IDocumentNameDialog,
    private formBuilder: FormBuilder
  ) {
    this.form = this.formBuilder.group({
      value: [config.value ?? '', [Validators.required, Validators.pattern(/^[^/\\]+$/)]]
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onConfirm() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.dialogRef.close(this.form.value.value.trim());
  }
}
